<script setup>
import { defineProps, defineEmits } from 'vue';

// Paleta de cores pré-definidas para etapas do Kanban
// Cores vibrantes e distintas para fácil diferenciação
const STAGE_COLORS = [
  '#6366F1', // Indigo
  '#8B5CF6', // Violet
  '#D946EF', // Fuchsia
  '#F43F5E', // Rose
  '#F97316', // Orange
  '#FBBF24', // Amber
  '#EAB308', // Yellow
  '#84CC16', // Lime
  '#22C55E', // Green
  '#10B981', // Emerald
  '#14B8A6', // Teal
  '#06B6D4', // Cyan
  '#3B82F6', // Blue
];

defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const selectColor = color => {
  emit('update:modelValue', color);
};
</script>

<template>
  <div class="stage-color-picker" @click.stop.prevent>
    <div class="color-palette">
      <button
        v-for="color in STAGE_COLORS"
        :key="color"
        type="button"
        class="color-swatch"
        :class="{ 'color-swatch--selected': modelValue === color }"
        :style="{ backgroundColor: color }"
        :title="color"
        @click="selectColor(color)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.stage-color-picker {
  width: 100%;
}

.color-palette {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0;
}

.color-swatch {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  }

  &--selected {
    border-color: #fff;
    box-shadow:
      0 0 0 3px currentColor,
      0 2px 6px rgba(0, 0, 0, 0.3);
    transform: scale(1.05);
  }
}
</style>
